import { FC, ReactNode } from 'react';

interface OptionDetailProps {
  label: ReactNode;
  detail?: string;
}

/** Option name with its secondary text floated to the right. */
const OptionDetail: FC<OptionDetailProps> = ({ label, detail }) => {
  if (!detail) return <>{label}</>;
  return <div>{label}<span className='xm-item-option-detail'>{detail}</span></div>;
};

export default OptionDetail;
